export enum InventoryCostCalculationMethod {
    Net = 'Net',
    Gross = 'Gross'
}
